import React                   from 'react';
import ReactDOM                from 'react-dom';
import styled, {ThemeProvider} from 'styled-components';
import Formulario              from '../componentes/Form';
import sendCounter             from '../componentes/Counter';
import ConverteURL             from '../modulos/ConverteURL.js';

/**
 * Formatos da landing page.
 * @type {{mobile: string, tablet: string, desktop: string}}
 */
const mediaQueries = {
    mobile: '(max-width: 800px)',
    tablet: '(max-width: 1400px)',
    desktop: '(min-width: 1401px)'
};

/**
 * Componentes estilizados.
 */
const
    Landing        = styled.div`
      background: linear-gradient(${props => props.fundo1}, ${props => props.fundo2});
      padding: 5% 0;
      ${props => props.theme.mode === 'desktop' && `
			min-height: 100vh;
		`}
    `,
    Layout         = styled.div`
      display: flex;
      flex-direction: column;
      max-width: 540px;
      width: 40%;
      margin: 5% auto;
      background-color: ${props => props.corFundoLayout};
      border-radius: 10px;
      box-shadow: 0px 7px 5px rgba(0, 0, 0, 0.25);

      ${props => props.theme.mode === 'mobile' ? `
			width: 90%;
			padding: 20px;
		` : `
			padding: 40px 20px;
		`}
      * {
        font-family: "Lato";
        white-space: pre-line;
        word-wrap: break-word;
        line-height: normal;
        margin: unset;
      }

      h1, p {
        margin-bottom: 30px;
      }
    `,
    Logo           = styled.div`
      text-align: center;

      ${props => props.theme.mode != 'mobile' && `
			margin-bottom: 40px;
		`}
      img {
        max-height: 84px;

        ${props => props.theme.mode === 'mobile' && `
				width: auto;
			`}
      }
    `,
    Titulo         = styled.h1`
      font-size: ${props => props.sizeTitulo};
      color: ${props => props.corTitulo};
      font-weight: bold;
    `,
    Descricao      = styled.p`
      font-size: ${props => props.sizeDescricao};
      color: ${props => props.corDescricao};
    `,
    Form           = styled(Formulario)`
      display: flex;
      flex-direction: column;
      text-align: center;

      pre {
        color: ${props => props.corFonte};
      }
    `,
    Campo          = styled.input`
      padding: 20px 25px;
      margin: 5px 0;
      border-radius: 5px;
      border: 1px solid #999;
      font-size: 16px;

      ${props => props.theme.mode === 'mobile' && `
			width: 100%;
			margin: 7px 0;
		`}
      &::placeholder {
        font-style: italic;
      }
    `,
    CallToAction   = styled.button`
      text-transform: uppercase;
      color: ${props => props.corFonte};
      background-color: ${props => props.corFundo};
      font-weight: bold;
      cursor: pointer;
      border: none;
      display: block;
      border-radius: 10px;
      box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.25);
      font-size: 20px;
      margin: 15px 0;

      &:hover {
        background-color: ${props => props.corFundo}cc;
      }

      ${props => props.theme.mode === 'mobile' ? `
			padding: 20px;
		` : `
			padding: 20px 25px;
		`}
    `,
    TermosDeUso    = styled.div`
      display: flex;
      align-items: center;
      justify-content: center;
      font-style: italic;
      margin-top: 20px;

      label {
        color: ${props => props.corTexto};
        font-size: ${(18 / 16)}rem;
        margin: 0 5px;
      }

      input {
        width: 18px;
        height: 18px;
      }

      a {
        font-size: ${(18 / 16)}rem;
        color: ${props => props.corTexto};
        text-decoration: underline;

        &:hover {
          color: ${props => props.corTexto}cc;
        }
      }
    `,
    TextoCTA       = styled.pre`
      display: block;
      font-style: italic;
      text-align: center;
      margin-top: 25px;
      font-size: ${16 / 16}rem;
      color: ${props => props.corFonte};
      max-width: 100%;
    `,

    WidgetWhatsapp = styled.a`
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
      margin: 10px;
      position: fixed;
      bottom: 30px;
      right: 40px;
      cursor: pointer;
      font-family: "Open Sans", Sans-Serif;

      .widget {
        position: relative;
        width: 80px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: rgba(37, 211, 102, 1);
        transform: scale(1);
        animation: pulse-green 2s infinite;

        &::after, &::before {
          position: absolute;
          left: -80px;
          display: none;
          transition: all ease .3s;
        }

        &::before {
          content: '';
          border-width: 8px 8px 0px 8px;
          border-style: solid;
          border-color: rgba(0, 0, 0, 0.9) transparent transparent transparent;
          margin-left: 60px;
          top: 33px;
          transform: rotate(-90deg);
        }

        &::after {
          content: attr(data-tooltip);
          background: rgba(0, 0, 0, 0.9);
          top: 54px;
          font-size: 14px;
          font-weight: normal;
          text-align: center;
          line-height: normal;
          text-transform: uppercase;
          width: 180px;
          margin-left: -132px;
          padding: 8px;
          color: #fff;
          transform: translateY(-100%);
          border-radius: 5px;
        }

        &:hover::after,
        &:hover::before {
          display: block;
        }

        &:hover {
          animation: none;
        }

        svg {
          width: 40px;
          height: 40px;
        }
      }

      @keyframes pulse-green {
        0% {
          -moz-box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
          box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
        }
        70% {
          -moz-box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
          box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
        }
        100% {
          -moz-box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
          box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
        }
      }

      ${props => props.theme.mode === 'mobile' ? `
				bottom: 30px;
				right: 30px;

				.widget{
						width: 60px;
						height: 60px;

						svg{
								width: 30px;
								height: 30px;
						}
				}
		` : ''}
    `
;


const TextoCallToAction = styled.pre`
  font-size: 1.4rem;
  font-family: "Open Sans", sans-serif;
  color: inherit;
  font-weight: 700;
  line-height: 1.4;
  white-space: pre-line;
  word-wrap: break-word;
  text-align: center;

  a {
    color: inherit;
    font-style: italic;
  }
`;

/**
 * Template *NOME* de landing page.
 */
class TemplateFormulario extends React.Component {
    /**
     * Construtor da classe. Cria o estado e, se não estiver no editor, adiciona o handler para quando a janela for redimensionada.
     * @param props
     */
    constructor(props) {
        super(props);

        /**
         * Modo da landing page.
         * @type {{mode: string}}
         */
        this.state = {
            mode: this.getMode(),
            enviadoComSucesso: false
        };

        if (this.props.editorActivePreviewTab) {
            window.addEventListener('resize', () => this.onResize());
        }
        /**
         * Elemento raíz da landing page.
         * @type {{current: HTMLElement}}
         */
        this.root = React.createRef();

    }


    componentDidMount() {
        if (this.props.urlVisualizacao) {
            sendCounter(this.props.urlVisualizacao);
        }
    }

    /**
     * Ao redimensionar a tela, verifique o modo.
     */
    onResize() {
        this.setState({
            mode: this.getMode()
        })
    }

    /**
     * Confere as media queries com o tamanho atual da janela.
     * @returns {string} Nome do modo atual.
     */
    getMode() {

        return this.props.editorActivePreviewTab ? (
            this.props.editorActivePreviewTab !== "mobile" ? (
                'tablet'
            ) : (
                'mobile'
            )
        ) : (
            Object.keys(mediaQueries).find(mediaQueryMode => window.matchMedia(mediaQueries[mediaQueryMode]).matches)
        );
    }

    /**
     * Renderiza o formulário.
     * @returns {ReactElement}
     */

    /**
     * Renderiza a landing page.
     * @returns {ReactElement}
     */
    render() {
        return (
            <ThemeProvider theme={{mode: this.state.mode}}>
                <Landing ref={this.root} fundo1={this.props.campos.corFundo1} fundo2={this.props.campos.corFundo2}>
                    <Layout
                        corFundoLayout={this.props.campos.corFundo3}
                    >
                        {this.props.campos.hasLogo && (
                            <Logo>
                                <a
                                    href={ConverteURL(this.props.campos.urlLogo)}
                                    title={this.props.campos.Titulo}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={this.props.campos.logo}
                                        alt={this.props.campos.Titulo}
                                    />
                                </a>
                            </Logo>
                        )}
                        {!this.state.enviadoComSucesso && this.props.campos.Titulo &&
                            <Titulo
                                sizeTitulo={this.props.campos.tamanhoFonteTitulo}
                                corTitulo={this.props.campos.corFonteTitulo}
                            >
                                {this.props.campos.Titulo}
                            </Titulo>
                        }
                        {!this.state.enviadoComSucesso && this.props.campos.Texto &&
                            <Descricao
                                sizeDescricao={this.props.campos.tamanhoFonteTexto}
                                corDescricao={this.props.campos.corFonteTexto}
                            >
                                {this.props.campos.Texto}
                            </Descricao>
                        }
                        {!this.state.enviadoComSucesso ? <Form
                            action={this.props.urlPost}
                            tipoRetorno={this.props.tipoRetorno}
                            valorRetorno={this.props.valorRetorno}
                            corFonte={this.props.campos.corFonteTitulo}
                            callback={() => {
                                this.setState({
                                    enviadoComSucesso: true
                                });
                            }}
                        >
                            {
                                // Bloqueia os campos do formulário após limite da length
                                this.props.camposFormulario.filter(e => e.enabled).length >= 999
                                    ? this.props.camposFormulario.filter(e => !e.enabled).map(e => e.editable = true)
                                    : this.props.camposFormulario.filter(e => !e.enabled).map(e => e.editable = false)
                            }
                            {this.props.camposFormulario.map(campo => {
                                const [primeiraLetra, ...campoCamelCase] = campo.placeholder

                                return campo.enabled && (
                                    <Campo
                                        key={campo.name}
                                        type={campo.name === 'email' ? "email" : "text"}
                                        name={campo.name}
                                        aria-label={campo.placeholder}
                                        placeholder={
                                            primeiraLetra.toUpperCase()
                                            + campoCamelCase.join('')
                                            + (campo.required ? '*' : '')
                                        }
                                        required={campo.required}
                                    />
                                )
                            })}
                            <CallToAction
                                corFonte={this.props.campos.corCallToAction}
                                corFundo={this.props.campos.fundoCallToAction}
                                type={!this.props.editorActivePreviewTab ? "submit" : "button"}
                            >
                                {this.props.campos.textoCallToAction}
                            </CallToAction>
                            {this.props.campos.textoAposCallToAction && this.props.campos.termos && (
                                <TextoCTA corFonte={this.props.campos.corFonteTexto}>
                                    {this.props.campos.textoAposCallToAction}
                                </TextoCTA>
                            )}
                            {this.props.campos.termos && (
                                <TermosDeUso corTexto={this.props.campos.corFonteTexto}>
                                    <input type="checkbox" id="termos_checkbox" required />
                                    <label htmlFor="termos_checkbox">
                                        Li e aceito os
                                    </label>
                                    <a
                                        href={ConverteURL(this.props.campos.termos)}
                                        title="Termos de uso"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        termos de uso
                                    </a>
                                </TermosDeUso>
                            )}
                        </Form> : (dadosLandingPage.campos.retornoForm === 'Mostrar mensagem de retorno'
                            ?
                            <TextoCallToAction>
                                {dadosLandingPage.campos.mensagem}
                            </TextoCallToAction>
                            : dadosLandingPage.campos.retornoForm === 'Download de arquivo'
                                ?
                                <TextoCallToAction>
                                    Agradecemos o cadastro! <br />
                                    <br />
                                    <a
                                        href={dadosLandingPage.campos.file}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Baixe aqui seu conteúdo
                                    </a>
                                </TextoCallToAction>
                                :
                                <TextoCallToAction>
                                    Agradecemos o cadastro! <br />
                                    <br />
                                    <a href={
                                        /http/.test(dadosLandingPage.campos.url)
                                            ? dadosLandingPage.campos.url
                                            : `http://www.${dadosLandingPage.campos.url}`

                                    }
                                       target="_blank"
                                       rel="noopener noreferrer"
                                    >
                                        Clique aqui
                                    </a>
                                </TextoCallToAction>)}
                    </Layout>

                    {this.props.campos.widgetWhatsappNumero && this.props.campos.widgetWhatsappNumero.length > 5 && (
                        <WidgetWhatsapp
                            href={`https://api.whatsapp.com/send/?phone=${this.props.campos.widgetWhatsappNumero}&text=${this.props.campos.widgetWhatsappMensagem}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <div className="widget" data-tooltip="envie uma mensagem">
                                <svg width="33" height="34" viewBox="0 0 33 34" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M28.2461 5.57949C25.282 2.52821 21.1846 0.871796 17 0.871796C8.10766 0.871796 0.958945 8.10769 1.04612 16.9128C1.04612 19.7026 1.83074 22.4051 3.13843 24.8462L0.871765 33.1282L9.32817 30.9487C11.682 32.2564 14.2974 32.8667 16.9128 32.8667C25.7179 32.8667 32.8666 25.6308 32.8666 16.8256C32.8666 12.5538 31.2102 8.54359 28.2461 5.57949ZM17 30.1641C14.6461 30.1641 12.2923 29.5538 10.2871 28.3333L9.76407 28.0718L4.70766 29.3795L6.01535 24.4103L5.66664 23.8872C1.83074 17.6974 3.66151 9.50256 9.93843 5.66667C16.2154 1.83077 24.323 3.66154 28.1589 9.93846C31.9948 16.2154 30.1641 24.3231 23.8871 28.159C21.882 29.4667 19.441 30.1641 17 30.1641ZM24.6718 20.4872L23.7128 20.0513C23.7128 20.0513 22.3179 19.441 21.4461 19.0051C21.3589 19.0051 21.2718 18.9179 21.1846 18.9179C20.923 18.9179 20.7487 19.0051 20.5743 19.0923C20.5743 19.0923 20.4871 19.1795 19.2666 20.5744C19.1795 20.7487 19.0051 20.8359 18.8307 20.8359H18.7436C18.6564 20.8359 18.482 20.7487 18.3948 20.6615L17.9589 20.4872C17 20.0513 16.1282 19.5282 15.4307 18.8308C15.2564 18.6564 14.9948 18.4821 14.8205 18.3077C14.2102 17.6974 13.6 17 13.1641 16.2154L13.0769 16.041C12.9897 15.9538 12.9897 15.8667 12.9025 15.6923C12.9025 15.5179 12.9025 15.3436 12.9897 15.2564C12.9897 15.2564 13.3384 14.8205 13.6 14.559C13.7743 14.3846 13.8615 14.1231 14.0359 13.9487C14.2102 13.6872 14.2974 13.3385 14.2102 13.0769C14.123 12.641 13.0769 10.2872 12.8154 9.7641C12.641 9.50256 12.4666 9.41538 12.2051 9.32821H11.2461C11.0718 9.32821 10.8974 9.41539 10.723 9.41539L10.6359 9.50256C10.4615 9.58974 10.2871 9.7641 10.1128 9.85128C9.93843 10.0256 9.85125 10.2 9.67689 10.3744C9.06664 11.159 8.71792 12.1179 8.71792 13.0769C8.71792 13.7744 8.89228 14.4718 9.15382 15.0821L9.241 15.3436C10.0256 17 11.0718 18.4821 12.4666 19.7897L12.8154 20.1385C13.0769 20.4 13.3384 20.5744 13.5128 20.8359C15.3436 22.4051 17.4359 23.5385 19.7897 24.1487C20.0513 24.2359 20.4 24.2359 20.6615 24.3231H21.5333C21.9692 24.3231 22.4923 24.1487 22.841 23.9744C23.1025 23.8 23.2769 23.8 23.4513 23.6256L23.6256 23.4513C23.8 23.2769 23.9743 23.1897 24.1487 23.0154C24.323 22.841 24.4974 22.6667 24.5846 22.4923C24.7589 22.1436 24.8461 21.7077 24.9333 21.2718V20.6615C24.9333 20.6615 24.8461 20.5744 24.6718 20.4872Z"
                                        fill="white" />
                                </svg>
                            </div>
                        </WidgetWhatsapp>
                    )
                    }
                </Landing>
            </ThemeProvider>
        );
    }
}

if (!!document.querySelector('#landing-page')) {
    window.landingPage = ReactDOM.render(
        <TemplateFormulario {...window.dadosLandingPage} />, document.querySelector('#landing-page'));
}

export default TemplateFormulario
